import { FC, useState } from "react"
import { ProductV2 } from "types"
import { PreviewOverlay } from "../PreviewOverlay"
import { MODEL_IMAGES } from "../PreviewOverlay/types"
import { ProductCategories } from "components/Navbar/types"

interface ProductPreviewOverlay {
  productPreview: ProductV2
  onClose: () => void
  effectType?: ProductCategories
}

export const ProductPreviewOverlay: FC<ProductPreviewOverlay> = ({
  productPreview,
  onClose,
  effectType = ProductCategories.MAKEUP,
}) => {
  const [activeColorIndex, setActiveColorIndex] = useState(0)
  const [image, setImage] = useState<string>(MODEL_IMAGES[0])

  return (
    <PreviewOverlay
      effectType={effectType}
      productItem={productPreview}
      onClose={onClose}
      image={image}
      onChangeImage={setImage}
      activeColorIndex={activeColorIndex}
      setActiveColorIndex={setActiveColorIndex}
    />
  )
}
